import React from 'react';
import { rem } from '../../styles/rem';

import { colors } from '../../styles/colors';
import { FontWeight } from '../../styles/typography';
import type { ElectionBadge } from './partyListModel';

type PartyElectionBadgesProps = {
  badges: ElectionBadge[];
  align?: 'left' | 'right';
};

const electionTypeBadgeStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: rem(28),
  minHeight: rem(24),
  px: rem(6),
  borderRadius: rem(4),
  backgroundColor: colors.components.partyListItem.Background.Hover,
  color: colors.base.Text.PrimaryStatic,
  fontSize: rem(14),
  fontWeight: FontWeight.Medium,
  lineHeight: rem(20),
};

function PartyElectionBadges({
  badges,
  align = 'left',
}: PartyElectionBadgesProps) {
  return (
    <span
      aria-hidden
      sx={{
        display: 'inline-flex',
        justifyContent: align === 'right' ? 'flex-end' : 'flex-start',
        gap: rem(6),
        whiteSpace: 'nowrap',
      }}
    >
      {badges.map((badge) => (
        <span
          key={badge.label}
          sx={electionTypeBadgeStyle}
          title={badge.title}
          data-election-type-badge
        >
          {badge.label}
        </span>
      ))}
    </span>
  );
}

export default PartyElectionBadges;
